import DOMPurify from 'dompurify'

// утилиты для работы с DOM
export class DOMManager {
	/**
	 * Устанавливает позицию курсора в указанном элементе.
	 * @param element - Элемент, в котором нужно установить курсор.
	 * @param position - Позиция курсора: 'start', 'end' или числовое значение.
	 * @param textNode - Текстовый узел, если указан то именно сюда установится курсор.
	 */
	static setCaretPosition(
		element: HTMLElement,
		position: 'start' | 'end' | number,
		textNode?: Node,
	): void {
		if (!element) {
			console.error('Element is not defined')
			return
		}

		if (typeof element.textContent !== 'string') {
			console.error('Element does not support text content')
			return
		}

		const textLength = element.textContent?.length || 0

		let caretPosition: number
		if (position === 'start') {
			caretPosition = 0
		}
		if (position === 'end') {
			caretPosition = textLength
		}
		if (typeof position === 'number') {
			caretPosition = Math.min(Math.max(position, 0), textLength)
		}

		const range = document.createRange()
		const selection = window.getSelection()

		if (!selection) {
			console.error('Selection API is not supported')
			return
		}

		if (textNode) {
			range.setStart(textNode, caretPosition!)
			range.collapse(true)
		} else {
			range.setStart(element, 0)
			range.collapse(false)
		}

		selection.removeAllRanges()
		selection.addRange(range)

		if (document.activeElement !== element) element.focus()
	}

	static getCaretPosition(element: HTMLElement, range: Range): number {
		const tempRange = document.createRange()
		tempRange.setStart(element, 0)
		tempRange.setEnd(range.startContainer, range.startOffset)
		return tempRange.toString().length
	}

	static sanitizeContent(content: string): string {
		return DOMPurify.sanitize(content, {
			ALLOWED_TAGS: ['span'],
			ALLOWED_ATTR: ['class', 'contentEditable'],
		})
	}

	/**
	 * Проверяет, содержит ли переданный HTMLElement невалидные теги.
	 * Невалидными считаются все теги, за исключением:
	 * элементов, содержащих класс переданный класс
	 *
	 * @param element - Элемент, который необходимо проверить.
	 * @param className - Класс, который необходимо исключить.
	 *
	 * @returns true, если в элементе обнаружены невалидные теги, иначе false.
	 */
	static containsInvalidTags(element: HTMLElement, className: string): boolean {
		const allTags = element.querySelectorAll('*')
		for (const tag of allTags) {
			if (tag.classList.contains(className)) continue
			return true
		}
		return false
	}
}
